const texts = {
  authorizationTabs: { signIn: "Entrar", signUp: "Inscrição" },
  general: {
    save: "Gravar",
    close: "Fechar",
    next: "Seguinte",
    clearStep: "Limpar este passo",
    tryAgain: "Tentar novamente",
    errorTitle: "Erro",
    service: "Serviço:",
    message: "Mensagem:",
    statusCode: "Código de Estado:",
  },
  months: {
    "1": "Janeiro",
    "2": "Fevereiro",
    "3": "Março",
    "4": "Abril",
    "5": "Maio",
    "6": "Junho",
    "7": "Julho",
    "8": "Agosto",
    "9": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
  },
  signIn: {
    title: "Bem-vindo a MultiMatch",
    description: "Crie a sua própria solução personalizada de Fertilizante de Libertação Controlada (CRF)",
    email: "Endereço eletrônico",
    password: "Senha",
    forgotPassword: "Esqueceu a senha?",
    keepMeLoggedIn: "Manter a minha sessão iniciada neste computador",
    keepMeLoggedInMobile: " Manter a minha sessão iniciada neste dispositivo",
    emailApproved: "O seu endereço de e-mail foi aprovadopor favor inicie sessão para continuar",
  },
  updatePassword: {
    title: "Definir nova senha",
    description: "A sua senha deve ter",
    password: "Nova senha",
    confirmPassword: "Confirmar senha",
    submitMessage: "Atualizar senha",
    success: "A sua senha foi alterada, a redirecionar para página de início de sessão.",
    UPDATE_PASSWORD_CONFIRMED: "A sua senha foi confirmada com sucesso",
    errors: {
      EMAIL_TOKEN_INVALID: "O seu token de reposição de senha é inválido",
      EMAIL_NOT_CONFIRMED: "O seu endereço de e-mail não foi confirmado.",
      MAIL_NOT_CONFIRMED: "O seu endereço de e-mail não foi confirmado.",
      PASSWORD_UPDATE_SUCCESS: "A sua senha foi atualizada",
      PASSWORD_UPDATE_FAILED: "A sua senha falhou a atualização",
      TEMP: "Token inválido ou endereço de e-mail não confirmado",
    },
    sendEmail: 'Enviamos uma mensagem de e-mail\nVerifique a sua caixa de entrada "',
    errorPasswordRequired: "Senha e confirmar senha não podem estar vazios",
  },
  signUp: {
    note: "Inscreva-se para gravar a sua informação para uso futuro",
    passwordNote: "A sua senha deve ter no mínimo 8 caracteres, conter uma letra maiúscula, minúscula e um número.",
    fullName: "Nome completo",
    country: "País",
    region: "Região",
    email: "Endereço eletrônico",
    mainInterest: "Interesse principal",
    expertise: "Especialidade",
    password: "Senha",
    confirmPassword: "Confirmar senha",
    iAccept: "Eu aceito",
    termsAndConditions: "Termos & condições Haifa",
    and: "e",
    privacyPolicy: "Política de Privacidade",
    next: "Seguinte",
    emailSent: "Enviamos uma mensagem de e-mail para {0}\n" + 'Verifique a sua caixa de entrada "',
    didntGet: "Não recebeu?",
    checkBoxError: "Por favor, Aprove",
  },
  validationErrors: {
    fieldIsRequired: "Os campos obrigatórios devem ser preenchidos",
    incorrectEmailFormat: "O endereço de e-mail não existe",
    passwordValidation: "Senha inválida",
    passwordsDontMatch: "As senhas não correspondem",
    lettersOnly: "Por favor, use letras apenas",
    incorrectEmail: "Endereço de e-mail incorreto",
    minimumValue: "Value must be larger than {0}",
    IncorrenctPassword: "Senha incorreta",
    emailExisted: "O endereço de e-mail já existe no sistema",
    termsCheckbox: "Necessário",
    valueOutOfRange: "O valor deve estar entre {0} e {1}",
    invalidDateFormat: "Por favor, introduza uma data válida",
    dateMustBeGreater: "A data de colheita deve ser superior à de plantação",
    dateMustBeAtLeastTwoMonths: "A data deve ser pelo menos dois meses",
    noServiceForSpecificCountry: "Nenhum serviço é fornecido para o país selecionado",
    dateMaxDatesTwelveMonth: "O máximo é um por ano.",
  },
  errorMessages: {
    generic: "Ocorreu um erro, por favor, tente novamente mais tarde",
    LOGIN_FAILED: "O nome de usuário ou senha está incorreto",
    MISSING_EMAIL: "O endereço de e-mail é obrigatório.",
    EMAIL_INVALID: "Endereço de e-mail incorreto",
    DUPLICATEUSERNAME: "Este endereço de e-mail já existe no sistema",
    PASSWORD_INVALID: "Senha inválida",
    USERNAME_INVALID: "O nome não pode conter caracteres especiais ou números",
    SPECIALIZATION_INVALID: "Especialização Inválida",
    MAIN_INTEREST_INVALID: "Interesse principal inválido",
    REGION_INVALID: "Região inválida",
    REGION_NOT_EXIST: "A região não existe",
    USER_NOT_FOUND: "O usuário não existe",
    USER_ALREADY_EXIST: "O usuário já existe",
    MISSING_VALUES_TO_CONFIRM_REGISTRATION: "A inscrição falhou - estão faltando valores",
    EMAIL_SENT_TO_USER: "Mensagem de e-mail enviada ao usuário",
    REGISTRATION_FAILED: "A inscrição falhou",
    TOKEN_INVALID: "Token de autenticação inválido",
    EMAIL_CONFIRMED_ALREADY: "O endereço de e-mail já foi confirmado",
    NO_SOLUTION_MATCH: "Nenhuma solução já pronta foi encontrada",
    EMAIL_CONFIRMED_SUCCESS: "Endereço de e-mail confirmado com sucesso",
    VALIDATION_FAILED: "A validação falhou",
    ACCEPT_TERMS_INVALID: "Valor de aceitação de termos inválido",
    SAVING_ITEM_FAILED: "Falha ao gravar item",
    SAVED_ITEM_NOT_FOUND: "O item não existe",
    UPDATING_RECIPE_ITEM_FAILED: "Falha ao atualizar item",
    REMOVING_RECIPE_ITEMS_FAILED: "Falha ao eliminar item de receita",
    REMOVING_GRAPH_ITEMS_FAILED: "Falha ao eliminar item de gráfico",
    ITEM_UPDATED_SUCCESSFULLY: "Item atualizado com sucesso",
    ITEM_DELETED_SUCCESSFULLY: "Item eliminado com sucesso",
    RAW_MATERIAL_PARAMETERS_NOT_VALID: "Falha ao gravar matéria-prima nova - Parâmetros inválidos",
    SAVING_RAW_MATERIAL_FAILED: "Falha ao gravar nova matéria-prima",
    RAW_MATERIAL_ALREADY_EXIST: "A matéria-prima já existe",
    REMOVING_ITEM_FAILED: "Falha ao eliminar item",
    UPDATING_ITEMS_FAILED: "Erro ao atualizar item na BD",
    CALCULATOR_IS_NOT_READY: "Dados de calculador a carregar...",
    NUTRIENT_TYPE_INVALID: "Tipo de nutriente inválido",
    BLEND_INVALID: "Mistura Multicote inválida",
    TYPE_INVALID: "tipo inválido para uma das propriedades",
    MISSING_SAVED_ITEM_ID: "ID de item gravado no pedido em falta",
    ITEM_NOT_FOUND: "Item não encontrado",
    RECIPE_TOTAL_ITEMS_COUNT_IS_MAXIMUM_6: "A receita não pode ter mais de 6 matérias-primas",
    RECIPE_HAS_TO_HAVE_MINIMUM_1_COATED_AND_MAXIMUM_5_UNCOATED_MATERIALS:
      "A receita deve incluir, pelo menos, uma matéria-prima revestida e até 5 materiais não-revestidos",
    ONE_OR_MORE_INVALID_MATERIALS_IDS_IN_RECIPE: "Um ou mais ids de matérias-primas na receita inválidos",
    PERCENTAGE_SUM_MUST_BE_100_IN_RECIPE: "Percentagem de mistura deve ser 100%",
    START_DATE_REQUIRED: "Data de início obrigatória",
    END_DATE_REQUIRED: "Data de fim obrigatória",
    END_DATE_MUST_BE_GRAETER_THEN_START_DATE: "A data de fim deve ser superior à data de início",
    YIELD_VALUE_REQUIRED: "Rendimento obrigatório",
    COUNTRY_INVALID: "País inválido",
    CROP_CODE_INVALID: "Colheita inválida",
    MESUREMENTS_INVALID: "Unidade de medição inválida",
    SOIL_AND_WATER_COMBINATION_INVALID: "Combinação Solo e Água inválida",
    MONTHS_AND_TEMPATURES_INVALID: "Valores de meses e temperaturas inválidos",
    shareWithNoSaving: "lamentamos, impossível partilhar item não-gravado",
    ITEM_NAME_TOO_SHORT: "nome demasiado curto",
    ITEM_RENAME_FAILED: "ITEM_RENAME_FAILED",
    ITEM_DUPLICATE_FAILED: "ITEM_DUPLICATE_FAILED",
    UPDATE_PROFILE_FAILED: "UPDATE_PROFILE_FAILED",
  },
  rightDrawer: {
    showMoreText: "Apresentar",
    contactUs: "Contact us",
    findDealer: "Find a dealer",
  },
  fmSummary: {
    shortSummaryTitle1: "Colheitas",
    shortSummaryTitle2: "Solo",
    shortSummaryTitle3: "Solução",
    shortSummaryTitle4: "Quinta",
    shortSummaryTitleGraphPage: "Personalizar",
    ourProducts: "Os nossos produtos",
    summary: "Dados Recolhidos",
    seeMoreProducts: "Ver mais produtos Multicote™",
    recipeCoatedElements: "Elementos revestidos",
    recipeUncoatedElements: "Elementos não-revestidos",
  },
  fmLeftMenu: {
    title: "Multimatch",
    subTitle: "Programas personalizados de nutrição de plantas",
    menuLabels: {
      label0: "Shlomit Adary",
      label1: "Solução Multicote Agri",
      label2: "Solução Multicote",
      label3: "Itens gravados",
      label4: "Sobre",
      label5: "Contate-nos",
    },
    logout: "Encerrar sessão",
  },
  steps: {
    cropsDesktop: "Colheitas",
    cropsMobile: "Características da sua colheita",
    soilDesktop: "Solo",
    soilMobile: "Temperaturas & Características do Solo",
    resultsDesktop: "Resultados",
    resultsMobile: "Resultados",
    farmDesktop: "Quinta\n(Opcional)",
    farmMobile: "Prática de quinta (Opcional)",
    customizeDesktop: "Personalizar\n(Opcional)",
    customizeMobile: "Construa a sua própria mistura (Opcional)",
  },
  agriSolution: {
    npkAlert: "NPK is Different from Crop Demand:",
    title: "Solução Multicote Agri",
    selectCropLabel: "Selecione a sua colheita",
    expectedYieldLabel: "Rendimento esperado",
    plotSizeLabel: "Rozmiar działki",
    plantingDateLabel: "Data de plantação",
    finalHarvestExpectedDate: "Data esperada de última colheita",
    selectPlotLocationLabel: "Selecionar localização da parcela",
    selectPlotLocationNote: "Seja o mais específico possível. Isso ajuda a avaliar os dados do clima",
    selectArea: "ou selecione uma área",
    selectOrAddNew: "Selecione de uma lista ou adicione um novo",
    onTheMap: "no mapa",
    select: "Selecionar",
    selectSoilLabel: "Temperaturas & Características do Solo",
    waterRegime: {
      title: "Selecionar regime de água",
      description: "Quais são as condições de precipitação da área?",
      sliderMarks: {
        "1": "Áridas",
        "2": "Semiáridas",
        "3": "Semitropical",
        "4": "Tropical",
      },
    },
    soilType: {
      title: "Selecionar tipo de solo",
      description: "Qual é o tipo de solo da parcela?",
      sliderMarks: {
        "1": "Areia, areia argilosa",
        "2": "Arenoso médio",
        "3": "Sedimentos, sedimentos argilosos, barro com sedimentos",
        "4": "Barro solto,  barro",
      },
    },
    soilWarning:
      "Os requisitos de nutrientes baseiam-se no rendimento esperado. Um programa de fertilizante Multicote está concebido para repor todos os macro nutrientes que a colheita irá remover. O solo é considerado um tampão, e o conteúdo de nutrientes do solo não é considerado. É, no entanto, boa prática agrícola recolher amostras de solo a cada 2 a 3 anos e aplicar os melhoramentos necessários de acordo com a análise do solo. Isto irá garantir que a fertilidade do solo é mantida e melhorada ao longo do tempo.",
  },
  fmDescriptionSnippet: {
    title: "Bem-vindo ao calculador de solução Multicote",
    description:
      "Um software baseado na nuvem para criar a sua própria solução personalizada de fertilizante de libertação controlada (CRF) para agricultores individuais ou corporativas em apenas alguns passos simples",
  },
  fmDropdownWithImg: { title: "Selecione a sua colheita" },
  back: "Retroceder",
  fmRecommendedProduct: {
    volume: "Volume de aplicação recomendado",
    method: "método de aplicação",
    link: "Clicar para obter um gráfico de libertação",
  },
  pageStep1: {
    soilTemp: "Selecionar temperatura do solo",
    change: "Alterar",
    note: "Por favor, selecione as suas colheitas da lista e introduza o seu rendimento esperado, data de plantação e data de colheita final.",
    cfpTitle: "Carbon & Environmental footprint",
    cfpDesc: "assessment tool is now included in MultiMatch to help you improve your environmental impact",
    cfpButton: "Read More",
  },
  fertilizationPopup: {
    title: "Aplicação de nutrientes fertilização",
    subTitle: "Conhece os seus níveis de nutrientes totais atuais sob a sua prática de fertilização atual?",
    thirdTitle: 'Selecione ""Conheço"" abaixo para calcular a sua nova fórmula personalizada',
    iKnow: "Conheço",
    iDontKnow: "Não conheço",
    next: "Seguinte",
  },
  saveProcessPopup: {
    title: "Gravar este processo",
    subTitle: "Notamos que tem um processo não gravado, pretende continuar?",
    dontShowThisMessage: "Não mostrar isto novamente",
    noThanks: "Não, obrigado",
    save: "Gravar",
  },
  clearStepPopup: {
    title: "Limpar este passo",
    subTitle: "Tem certeza que pretende limpar os dados deste passo?",
    dontShowThisMessage: "Não mostrar isto novamente",
    noGoBack: "Retroceder",
    clear: "Limpar os meus dados",
  },
  deleteItemPopup: {
    title: "Eliminar item",
    subTitle: "Tem certeza que pretende eliminar este item?",
    no: "Não",
    yes: "Sim",
  },
  saveItemPopup: {
    title: "Gravar Solução",
    label1: "Nome da solução",
    label2: "Área",
    getBack: "Gostaria que o Agrônomo Haifa faça a revisão da minha seleção e volte a contatar-me.",
    save: "Gravar",
    snackbar: "Item gravado",
  },
  pageStep4: {
    title: "Prática de quinta",
    table: {
      nutrients: "Nutrientes",
      nutrientsUnit: "(Kg/Ha)",
      label1: "Prática de agricultor",
      label2: "Requisitos de colheita",
      label3: "Nutrientes salvos do ambiente",
    },
    question: "Qual é a sua prática?",
    questionDescription:
      "se já está usando alguns fertilizantes que estão a produzir rendimentos normais, por favor, indique-nos o NPK total aplicado por estação. Iremos usar estas taxas para calcular as taxas Multicote ótimas para a sua fórmula personalizada.",
    fill: "Preencha a sua prática",
    buttomDescription:
      "Usando o Multicote, a eficiência de utilização de nutrientes dos nutrientes revestidos é altamente melhorada, isto permite-nos reduzir o total de nutrientes aplicado, reduzindo assim a poluição das águas subterrâneas e a acumulação indesejada de concentrações de sal no solo.",
    warningText1: "Recomendamos que contate um ",
    warningText2: "Agrônomo Profissional ou Distribuidor Haifa",
    warningText3: "para confirmar a sua seleção antes de aplicar.",
    clearThisStep: "Limpar este passo",
    cfpBanner: "Data of used application rates helps the system calculate carbon and environmental footprint ",
    next: "Seguinte",
    save: "Gravar",
  },
  multicoteTable: { mesurmentUnit: " (%)" },
  mainInterests: { OFA: "Agricultura em campo aberto", N: "Viveiro" },
  metricMethods: { "1": "Métrico", "2": "Imperial" },
  specialties: {
    "1": "Jardinagem \\ hobby",
    "2": "Agricultor",
    "3": "Empreiteiro Agrícola",
    "4": "Formação Agrícola \\ serviços",
    "5": "Comércio",
    "6": "Outro",
  },
  PageReleaseChart: {
    greenMessage: {
      title1: "COMO USAR",
      description1: " Aplicar sempre as misturas de produtos Multicote na zona da raiz.",
      description2: "Para um desempenho ótimo, este deve ser coberto com solo ou outra cobertura.",
      subTitle: "Melhores práticas:",
      description3:
        "Aplicar na fila durante o plantio. Segundo a melhor distribuição antes do cultivo e incorporar as misturas Multicote na cama de plantio.",
      title2: "QUANDO",
      description4: "Aquando do plantio ou durante a preparação da parcela, mas não mais de 2 semanas antes do plantio.",
      title3: "QUANTO",
      description5:
        "A tecnologia Multicote é de utilização segura, mas para as melhores práticas, certifique-se que a maquinaria está devidamente calibrada.",
      title4: "CURVA DE LIBERTAÇÃO",
      description6: "A curva de libertação apresenta a libertação de nutrientes de acordo com a temperatura do solo esperada",
      radioButtonLabel: 'Selecione um tema"',
      shareUnsavedItem: "lamentamos, impossível partilhar item não-gravado",
    },
    currentDayRemainingReleaseValues: {
      preValue: "Mês",
      postValue: "NPK restante:",
      currentPrecentage: "Remaining NPK (Percentage):",
      Percentage: "(Percentage)",
    },
    sendToAgronomist: {
      preUserName: "O usuário",
      preCrop: "está a planear uma solução para a colheita",
      preYield: "com um rendimento esperado de",
      preStartingDate: "Data de início:",
      preFinalDate: "Data de fim:",
      preSolutionName: "Solução:",
      materialCode: "Material code:",
      preVolumeApplication: "Volume de aplicação",
    },
    warning: {
      description: 'Será necessária a aplicação adicional de elementos secundários e micro. Para uma recomendação completa"',
      boldDescription: "contate o seu Agrônomo ou Distribuidor Haifa local",
    },
    buttons: {
      downloadFile: "Descarregar PDF",
      sendToPro: "Enviar para Agrônomo",
      shareLink: {
        desktop: "Partilhar ligaֳ§ֳ£o",
        mobile: "Partilhar",
      },
    },
  },
  wideTable: {
    kodkod: { title1: "Libertação de material", title2: "por Mês (Kg/Ha)" },
    sideLabel: { label1: "N (var)", label2: "P", label2_1: "O", label3: "K" },
    months: {
      month1: "Jan",
      month2: "Fev.",
      month3: "Mar",
      month4: "Abr.",
      month5: "Mai",
      month6: "Jun.",
      month7: "Jul",
      month8: "Ago.",
      month9: "Set",
      month10: "Out",
      month11: "Nov.",
      month12: "Dez",
    },
    caroselHeader: { title: "Libertação Mensal (%)" },
    next: "Seguinte",
    back: "Retroceder",
  },
  saveItemsPage: {
    title: "Soluções Gravadas",
    inputPlaceholder: "Introduza um tipo de colheita ou uma área para encontrar as suas misturas gravadas",
    mobile_inputPlaceholder: "Introduza um tipo de colheita ou uma área",
    clearAll: "Limpar todas",
    loadMore: "Carregar mais",
    savedItemCard: {
      rename: "Alterar nome",
      delete: "Eliminar",
      duplicate: "Duplicar",
      contact: "Contatar",
      showTo: "Mostrar item ao Agrônomo Haifa",
    },
  },
  multicoteSolutionPage: {
    stepOne: {
      firstInput: "Selecionar mistura",
      secondInput: "Data de Início",
      radioLabel1: "P2O5 K20",
      radioLabel2: "PK",
      selectTemperature: " Selecionar temperatura",
      calculateButton: "Calcular",
      setTempratureButton: "Definir Temperaturas",
    },
    title: "Solução Multicote",
    changeCalculationSetting: "Alterar definição de cálculo",
    save: "Gravar",
    line: "Linha",
    bar: "Barra",
    graphCodCodTitle: "Libertação de material",
  },
  pageStep3: {
    carbonFootprintLoadingText: "Proszę nie zamykać tego okna",
    carbonFootprintDesc: "Ocena śladu środowiskowego i węglowego dla całego cyklu uprawy",
    carbonFootprintButtonText: "Oblicz to dla mnie!",
    subTitle: "A sua recomendação",
    customize: {
      bestSuit: "Fórmula mais adequada",
      subDescription: "Encontramos esta fórmula que melhor se adequa aos requisitos da sua colheita",
      title: "Pretende ajustar a fórmula?",
      secondSubDescription:
        "Pode ajustar esta fórmula ou criar a sua personalizada para se adequar às suas condições locais em apenas alguns passos simples",
      button: "Ajustar fórmula",
      topLink: "Gráfico de libertação",
    },
    bottomTitle: "Fórmula pronta a usar",
    bottomDescriptionWithMatch: "Esta é a fórmula pronta a usar mais recomendada próximo da sua recomendação",
    bottomDescriptionWithoutMatch:
      "Não conseguimos encontrar uma fórmula correspondente que fosse adequada aos requisitos das condições da sua colheita, solo e clima",
    recommendedProduct: {
      description:
        "A nossa recomendação baseia-se nos requisitos da colheita para NPK apenas,  de acordo com os requisitos conhecidos desses nutrientes. As aplicações de nutrientes secundários e micronutrientes serão realizadas de acordo com a análise de solo e os requisitos da colheita.",
    },
    save: "Gravar",
    inSoil: "No solo",
    metric: "Kg/Ha",
    imperial: "ST/Acre",
  },
  pageStep5: {
    title: "Construir a sua própria mistura",
    updateButton: "Atualizar Cálculo N, P, K",
    recipeValidationError: "A receita tem de ter no mínimo 1 material revestido, no máximo 6 itens no total",
    save: "Gravar",
    bestSolution: "Melhor solução",
    subTitle1: "Selecione até 6 Materiais no total",
    coated: "Revestido",
    uncoated: "Não-Revestido",
    completePercentage: "Percentagem completa da sua mistura Multicote:",
    missing: "em falta",
    clear: "Limpar este passo",
    continueButton: "Continuar para a tabela de Libertação",
    bottomDrawer: {
      savedItem: "Item gravado",
      rename: "Alterar nome",
      delete: "Eliminar",
      reset: "Repor",
      update: "Atualizar",
    },
    uncoatedHelperText: "",
    updateCard: {
      leftSpan: "N, P, K é calculado pela sua seleção de materiais:",
      errorMessage: {
        missingWord: "Increase",
        extraWord: "Decrease",
        rightPart: "% for calculation",
      },
    },
  },
  userAreaPage: {
    title: "O Meu Perfil",
    tab1: "Perfil do Usuário",
    tab2: "O meu banco de matérias-primas",
    inputLabel1: "Nome completo",
    inputLabel2: "País",
    inputLabel3: "Endereço eletrônico",
    inputLabel4: "O seu principal interesse",
    inputLabel5: "Experiência (Opcional)",
    button: "Atualizar",
    inputSecondPage: "Não-Revestido",
    messages: { success: "Perfil Atualizado com sucesso" },
    uncoatedInputHelperText: "",
  },
  contactUs: {
    title: "Tem uma pergunta? Necessita de uma consulta?",
    secondTitle: "obrigado por visitar a nossa plataforma",
    description:
      "Teremos todo o prazer em ajudar com qualquer questão que possa ter e adoraríamos ouvir sobre a sua experiência para podermos continuar a melhorar as nossas ofertas.",
    inputLabel1: "País",
    inputLabel2: "Região",
    inputLabel3: "Posto",
    inputLabel4: "Método de cultivo",
    inputLabel5: "Número de celular",
    inputLabel6: "Tamanho da área (ha)",
    inputLabel7: "Endereço de e-mail",
    inputLabel8: "A sua mensagem",
    back: "Retroceder",
    send: "Enviar",
    messages: {
      success: "Obrigado pela sua mensagem de e-mail. Entraremos em contacto consigo em breve.",
      invalidPhoneNumber: "Número de celular inválido",
    },
  },
  PDFfile: {
    mateData: {
      createdBy: "Criado por:",
      name: "Nome:",
      location: "Localização:",
      phoneNumber: "Número de Telefone:",
      Date: "Data:",
      Time: "Hora:",
    },
    summaryData: {
      nutrientsApplied: "Nutrientes aplicados:",
      collectedDataTitle: "Dados recolhidos:",
      cropsTitle: "Colheitas",
      cropProp: "Colheita",
      yieldProp: "Rendimento",
      plantingDateProp: "Data de plantação",
      plotSize: "Plot Size",
      harvestDateProp: "Data de colheita",
      soilTitle: "Solo",
      WaterRegimeProp: "Regime de água",
      soilProp: "Solo",
      customizedTitle: "Personalizado",
      recipeCoatedTitle: "Elementos revestidos",
      recipeUncoatedTitle: "Elementos não-revestidos",
      recommended: "Recomendado",
      MaterialCodeProp: "Código de material",
    },
    waver: {
      title: "ISENÇÃO DE RESPONSABILIDADE",
      body: {
        before: "Before using, the grower shall determine the suitability of the product for his intended use.",
        theGrower: "The grower assumes all risk and liability for consequential and incidental damages. This product",
        isSold: "is sold without warranty of any kind, expressed or implied, as to  its merchantability",
        orFitness: " or fitness for a particular purpose.",
        caution: "Caution: ",
        harmful: "Harmful is swallowed. Keep out of reach of children. Store under cool, dry conditions.",
      },
    },
    descriptionRecommended:
      "A nossa recomendação baseia-se nos requisitos da colheita quanto a NPK apenas, de acordo com os requisitos\nconhecidos destesnutrientes. Serão realizadas aplicações de nutrientes secundários e micronutrientes de acordo com\na análise do solo e os requisitos da colheita.",
    howToUse: {
      title: "COMO USAR",
      body: {
        firstLine: "Aplicar sempre as misturas de produtos Multicote na zona da raiz.",
        secondLine: "For optimal performance, it must be covered with a few centimeters of soil",
        thirdLine: "or mulch.",
        fourthLinePartOne: "Best practice:",
        fourthLinePartTwo: "Apply in row while seeding.",
        fifthLinePartOne: "2nd best:",
        fifthLinePartTwo: "Spread evenly before cultivation and incorporate the Multicote™",
        fifthLinePartThree: "blends into the seedbed.",
        forOptimalPerformance: "For optimal performance, mix Multicote™ with potting soil before planting.",
        mixMulticote: " Mix Multicote™ with potting soil before planting.",
        secondBestPractice: "2nd best practice - Dibbling:",
        forLate: "for late application, make holes around the plant and apply ,Multicote™",
        evenly: "evenly, cover with soil.",
      },
    },
    when: {
      title: "QUANDO",
      body: {
        firstLine: "While seeding or at plot preparation, but not more than 2 weeks prior to ",
        secondLine: "planting. ",
      },
    },
    howMuch: {
      title: "QUANTO",
      body: {
        firstLine: "Multicote™ technology is safe for use, but for best practice make sure",
        secondLine: "machinery is correctly calibrated.",
      },
    },
    releaseCurve: {
      title: "CURVA DE LIBERTAÇÃO",
      body: "A curva de libertação apresenta a libertação de nutrientes de acordo com as temperaturas de solo esperadas",
    },
    nameOfFile: "Multicote™ - Our Solution.pdf",
  },
  ShareEmail: {
    title: "Instruções ",
    body: {
      please: "Por favor",
      find: "encontre",
      attached: "em anexo",
      recommendation: "recomendação",
      Thank: "Obrigado",
      you: "",
      Haifa: "Haifa",
      Group: "Grupo",
    },
  },
  autoCompleteInput: {
    firstSpan: "Estes valores são inválidos",
    secondSpan: "máx. N, P, K é 46, 54, 62",
    thirdSpan: "Soma máx. é 66",
    noOptions: "Sem Opções",
  },
  sideMenu: {
    termsAndCondition: {
      title: "Termos e Condições",
      contentTitle: "Termos de utilização",
    },
    privacyPolicy: { title: "Política de Privacidade" },
    copyRightTitle: "Direitos de autor 2021 Haifa",
    poweredBy: "Alimentado por",
  },
  cfpTable: {
    savingTitle: "Oszczędność ekwiwalentu CO2",
    reducedCo2: "Na",
    reducedCo2PerPlot: "Na działkę",
    rating: {
      excellent: "Doskonałe",
      worse: "Gorzej",
    },
    tableColumns: {
      envParams: "Parametry środowiskowe",
      multiTech: "Technologia Multicote™",
      tradTech: "Tradycyjne zastosowanie",
      performanceRating: "Wydajność oceny technologii Multicote™",
      index: "Indeks",
    },
    tableRows: {
      carbonFootprint: {
        label: "Ślad węglowy",
        measureUnit: "kg ekwiwalentu CO2 / kg produktu",
      },
      nLeaching: {
        label: "Wypłukiwanie azotu",
        measureUnit: "kg NO3 / kg produktu",
      },
      nRunOff: {
        label: "Straty azotu",
        measureUnit: "kg NO3 / kg produktu",
      },
      nVolatilization: {
        label: "Ulatnianie się azotu",
        measureUnit: "kg NH3 / kg produktu",
      },
      terrestrialEutrophication: {
        label: "Eutrofizacja gleby",
        measureUnit: "kg ekwiwalentu P / kg produktu",
      },
    },
    carbonBannerTitle: "Obliczanie oszczędności emisji dwutlenku węgla",
    carbonBannerText: "((Ślad węglowy tradycyjnego zastosowania)/ha - (Ślad węglowy technologii Multicote™)/ha) X Oczekiwane plony T/Ha)",
  },
};
export default texts;
